"use client";

import { sha256 } from "js-sha256";
import Cookies from "js-cookie";

import { PinterestPropertyType } from "~/services/api/services/types/EventsEnum";
import { COOKIES } from "~/types/Cookie";

type UserDataParams = {
    client_ip_address: string | undefined;
    client_user_agent: string | undefined;
    ge?: string[] | null;
    country?: string[] | null;
    em?: string[] | null;
    fn?: string[] | null;
    ln?: string[] | null;
    ph?: string[] | null;
    ct?: string[] | null;
    st?: string[] | null;
    zp?: string[] | null;
    external_id?: string[] | null;
};

export function sendPinterestEvent(sendPinterestEvent, args) {
    const user_data: UserDataParams = {
        client_ip_address: Cookies.get(COOKIES.IP_ADDRESS),
        client_user_agent: navigator.userAgent,
        ge: [sha256("f")],
        country: [sha256("us")],
    };

    if (args.email) {
        user_data.em = [sha256(args.email)];
    }

    if (args.first_name) {
        user_data.fn = [sha256(args.first_name)];
    }

    if (args.last_name) {
        user_data.ln = [sha256(args.last_name)];
    }

    if (args.phone) {
        user_data.ph = [sha256(args.phone)];
    }

    if (args.city) {
        user_data.ct = [sha256(args.city)];
    }

    if (args.state) {
        user_data.st = [sha256(args.state)];
    }

    if (args.zip_code) {
        user_data.zp = [sha256(args.zip_code)];
    }

    if (args.external_id) {
        user_data.external_id = [sha256(args.external_id)];
    }

    sendPinterestEvent({
        type: PinterestPropertyType.PINTEREST_EVENT,
        properties: {
            data: [
                {
                    action_source: "web",
                    event_id: args.event_id || Date.now().toString(),
                    event_name: args.event_name,
                    event_time: Math.floor(Date.now() / 1000 ),
                    event_source_url: window.location.href,
                    user_data: user_data,
                    custom_data: args.custom_data
                }
            ],
        },
    });

    return null;
}